import React from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import logo from './logo.svg'
import image_1 from 'images/login-image-custom-1.jpg'
import image_2 from 'images/login-image-custom-2.jpg'
import pattern from './pattern.svg'
import Fields from './Fields'

const Logo = styled.div`
    background-image: url(${logo});
    background-repeat: no-repeat;
    display: inline-block;
    height: 32px;
    width: 152px;
    margin: auto;
`

const Form = styled.form`
    display: flex;
    flex-direction: column;
    padding: 0 36px;
`

const Main = styled.div`
    position: absolute;
    width: 100%;
    opacity: 0;
    transition: all .5s cubic-bezier(.55, 0, .1, 1);

    > div {
        background-position-x: -30px;
        background-repeat: no-repeat;
        background-size: cover;
        height: 500px;
    }
`

const Top = styled.div`
    background-image: url(${pattern});
    background-color: #415dd4;
    background-blend-mode: color-burn;
    background-size: cover;
    width: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
    height: 150px;
`

const Container = styled.div`
    background-color: #fff;
    max-height: 100vh;
    overflow: hidden;
    height: 100vh;
`

const Tab = styled(Link)`
    display: inline-block;
    text-align: center;
    padding: 50px 20px;
    width: 50%;
    text-transform: uppercase;
    color: ${props => props.active === 'true' ? '#415dd4' : '#7c9198'};
    font-weight: lighter;
    letter-spacing: 2px;
    font-size: 13px;
    transition: color .3s cubic-bezier(.55, 0, .1, 1);
    box-sizing: border-box;
`

const types = [
    'login',
    'registration'
]

const Mobile = ({type, intl, password, repeat, instance, instances, handleChange, handleClickPassword, handleRegistration, handleLogin}) => (
	<Container>
		<Top type={type}>
			<Logo />
		</Top>
		<div>
			{types.map((item, index) =>
				<Tab key={index} active={type === item ? 'true' : 'false'} to={`/${item}`}>
					{intl.formatMessage({id: `login.${item}_label`})}
				</Tab>
			)}
		</div>
		<Main style={type === 'login' ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'}}>
			<Form method="post" onSubmit={handleLogin}>
				<Fields
					password={password}
					handleClickPassword={handleClickPassword}
					instances={instances}
					instance={instance}
					handleChange={handleChange}
					handleLogin={handleLogin}
					type={type}
				/>
			</Form>
			<div style={{backgroundImage: `url(${image_1})`}} />
		</Main>
		<Main style={type === 'registration' ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'}}>
			<Form method="post" onSubmit={handleRegistration}>
				<Fields
					password={password}
					handleClickPassword={handleClickPassword}
					instances={instances}
					instance={instance}
					handleChange={handleChange}
					handleRegistration={handleRegistration}
					type={type}
					repeat={repeat}
				/>
			</Form>
			<div style={{backgroundImage: `url(${image_2})`, backgroundPositionY: '10px', height: '315px'}}/>
		</Main>
	</Container>
)

export default injectIntl(Mobile)
